import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-block text-xs font-medium text-secondary-600 bg-secondary-100/80 px-3 py-1 rounded-full mb-3">
              精选攻略
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
              旅行灵感
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              资深旅行者倾心撰写，为你带来最地道的亚洲旅行攻略
            </p>
          </div>
          <Link
            to="/category/southeast-asia"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            浏览全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block cursor-pointer"
            >
              <article className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-secondary-200 transition-all duration-300 h-full flex flex-col">
                <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden">
                  <img
                    src={article.image}
                    alt={`${article.title} - 亚洲天堂旅行攻略`}
                    title={`${article.title} | 亚洲天堂`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-xs bg-secondary-500 text-white px-2.5 py-1 rounded-full">
                      {article.categoryName}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5 flex-1 flex flex-col">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-secondary-600 transition-colors line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm mt-2 line-clamp-2 leading-relaxed flex-1">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/50">
                    <span className="text-xs text-foreground-500">{article.author}</span>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {article.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.readTime}
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}